import { axios } from '@Root/API'

export const getAll = (id, params) => {
	return axios.get(`delivery-roles-module/${id}`, { params })
}
